import { Check, Copy, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import type { HouseholdInvite } from '@/types/household'

interface HouseholdInvitesListProps {
  invites: HouseholdInvite[]
  copiedInviteId: string | null
  onCopyInviteLink: (inviteCode: string) => void
  onDeleteInvite: (inviteId: string) => void
}

export function HouseholdInvitesList({
  invites,
  copiedInviteId,
  onCopyInviteLink,
  onDeleteInvite,
}: HouseholdInvitesListProps) {
  if (invites.length === 0) {
    return null
  }

  return (
    <div>
      <h4 className="mb-2 text-sm font-medium">Openstaande Uitnodigingen</h4>
      <div className="space-y-2">
        {invites.map((invite) => (
          <div key={invite.id} className="flex items-center justify-between rounded bg-gray-50 p-2">
            <div className="text-sm">
              <span className="font-medium">{invite.email}</span>
              <Badge variant="outline" className="ml-2 text-xs">
                {invite.role}
              </Badge>
            </div>
            <div className="flex gap-1">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onCopyInviteLink(invite.invite_code)}
                title="Kopieer uitnodigingslink"
              >
                {copiedInviteId === invite.invite_code ? (
                  <Check className="h-4 w-4 text-green-600" />
                ) : (
                  <Copy className="h-4 w-4" />
                )}
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDeleteInvite(invite.id)}
                className="text-red-600 hover:text-red-700"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
